// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2iN4n","error":"Textarea_error__3xxjr","readonly":"Textarea_readonly__2Rytt","disabled":"Textarea_disabled__i0OTC"};